/* Copyright (c) 2020-present CloudIO Inc */

import { page as Tabs } from './tabs';
import { page as Drawer } from './drawer';
import { page as Form } from './form';
import { Page } from 'componentregistry';

export interface PageTemplate {
  name: string;
  page: Page;
  pageId: string;
  height?: number;
}

export const non_ds_registry: PageTemplate[] = [
  { page: Tabs, name: 'Page with Tabs', pageId: 'tabs', height: 400 },
  { page: Drawer, name: 'Page with Drawer', pageId: 'drawer', height: 200 },
  { page: Form, name: 'Page with Form', pageId: 'form', height: 500 },
];
